/* This piece of code has been taken form https://github.com/clauderic/react-sortable-hoc */

export default function defaultGetHelperDimensions({ node }) {
    return {
        height: node.offsetHeight,
        width: node.offsetWidth,
    };
}
